import React from "react";

const FooterDetails = ({title}) => {
    return (
        <div className="container bg-dark-navy-blue ftr-details">
        {title === 'Contact Us' &&
            <div>
                <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/cdc-info/index.html" target="_blank" rel="noopener noreferrer">Contact Us</a>
                <div className="sm-pad-tb">
                    <div>
                        Call 800-232-4636
                    </div>
                    <div>
                        Contact CDC
                    </div>
                </div>
            </div> 
        }

        {title === 'About CDC' &&
            <div>
                <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/about/" target="_blank" rel="noopener noreferrer">About CDC</a>
                <div className="sm-pad-tb">
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/media/" target="_blank" rel="noopener noreferrer">Pressroom</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/about/organization/" target="_blank" rel="noopener noreferrer">Mission & Organization</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/budget/" target="_blank" rel="noopener noreferrer">Budget & Funding</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://jobs.cdc.gov/index.html" target="_blank" rel="noopener noreferrer">Careers & Jobs</a>
                    </div>
                </div>
            </div> 
        }

        {title === 'Policies' &&
            <div className="flex">
                <div style={{width: '25%'}}>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/other/accessibility.html" target="_blank" rel="noopener noreferrer">Accessibility</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/Other/disclaimer.html#exit-notification" target="_blank" rel="noopener noreferrer">External Links</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/other/privacy.html" target="_blank" rel="noopener noreferrer">Privacy</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/Other/policies.html" target="_blank" rel="noopener noreferrer">Web Policies</a>
                    </div>
                </div>
                <div style={{width: '25%'}}>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/foia/" target="_blank" rel="noopener noreferrer">FOIA</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://oig.hhs.gov/" target="_blank" rel="noopener noreferrer">OIG</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/oeeo/about/index.html" target="_blank" rel="noopener noreferrer">No Fear Act</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.cdc.gov/other/nondiscrimination.html" target="_blank" rel="noopener noreferrer">Nondiscrimination</a>
                    </div>
                    <div>
                        <a className="no-decor c-w underline-hover" href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html" target="_blank" rel="noopener noreferrer">Vulnerability Disclosure Policy</a>
                    </div>
                </div>
                <div style={{ width: '50%'}}></div>
            </div> 
        }

        {title === 'Archive' &&
            <div>
                <div>
                    <a className="no-decor c-w underline-hover" href="https://archive.cdc.gov/" target="_blank" rel="noopener noreferrer">CDC Archive</a>
                </div>
                <div>
                    <a className="no-decor c-w underline-hover" href="https://stacks.cdc.gov/" target="_blank" rel="noopener noreferrer">Public Health Publications</a>
                </div>
            </div> 
        }
        </div>
    )
}

export default FooterDetails